import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface VoidPaymentDialogData {
  paymentDisplayId: string;
  patientName: string;
  totalReceived: number;
  status: string;
}

@Component({
  selector: 'app-void-payment-dialog',
  templateUrl: './void-payment-dialog.component.html',
  styleUrls: ['./void-payment-dialog.component.css']
})
export class VoidPaymentDialogComponent {
  reason: string = '';
  reasonError: string = '';

  constructor(
    public dialogRef: MatDialogRef<VoidPaymentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: VoidPaymentDialogData
  ) { }

  getStatusClass(status: string): string {
    if (!status) {
      return 'status-applied';
    }
    return 'status-' + status.trim().toLowerCase().replace(/\s+/g, '-');
  }

  onClose(): void {
    this.dialogRef.close(null);
  }

  onConfirm(): void {
    const trimmed = (this.reason || '').trim();
    if (!trimmed) {
      this.reasonError = 'Reason for voiding is required.';
      return;
    }
    this.reasonError = '';
    this.dialogRef.close(trimmed);
  }
}
